import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ChatAvatar from '../../../shared/components/ChatAvatar';
import { ellipsisBetweenText } from '../../../shared/utils/smartutils';

const AppointmentDetail = ({ t, appointment, onAppointmentSelect }) => {
  return (
    <button
      type="button"
      className="appointment-detail"
      onClick={onAppointmentSelect}
    >
      <div className="appointment-detail-header">
        <div>
          <ChatAvatar
            name={appointment.nameItem}
            size="50"
            round="50%"
            urlPhoto={appointment.linkIconItem}
          />
        </div>
        <div
          className="d-flex align-items-center tooltip-test"
          title={appointment.note}
        >
          <div className="font-weight-bold">{appointment.levelOne}&#58;</div>
          <div className="ml-1">{ellipsisBetweenText(appointment.note)}</div>
        </div>
        <div>
          {appointment.dateNote} - {appointment.hourNote}
        </div>
      </div>
      <div className="appointment-detail-content">
        <div className="detail-content-label">
          {t('general.item-description')}&#58;
        </div>
        <div className="detail-content-value">
          {appointment.descriptionItem}
        </div>
        <div className="detail-content-label">{t('general.adjunct')}&#58;</div>
        {appointment.noteComplement && (
          <div className="detail-content-value">
            {appointment.noteComplement}
          </div>
        )}
      </div>
    </button>
  );
};

AppointmentDetail.propTypes = {
  t: PropTypes.func.isRequired,
  onAppointmentSelect: PropTypes.func.isRequired,
  appointment: PropTypes.shape({
    noteComplement: PropTypes.string,
    hourNote: PropTypes.string.isRequired,
    note: PropTypes.string.isRequired,
    dateNote: PropTypes.string.isRequired,
    levelOne: PropTypes.string.isRequired,
    linkIconItem: PropTypes.string.isRequired,
    nameItem: PropTypes.string.isRequired,
    descriptionItem: PropTypes.string.isRequired,
  }).isRequired,
};

export default withTranslation('common')(AppointmentDetail);
